<template>
    <div>网店装修</div>
</template>

<script>
    export default {
        name: "Index"
    }
</script>

<style scoped>

</style>